import { OnboardingTooltip } from '@karnov/kui-react'

import { useConversationsQuery } from 'api/conversations/queries'

import { useDebouncedSearchValue } from 'hooks/useDebouncedSearchValue'
import { useOnboardingTooltip } from 'hooks/useOnboardingTooltip'
import { useTranslation } from 'services/i18n'

import type { FC } from 'react'

export const ConversationExpirationOnboarding: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation_history',
  })

  const debouncedValue = useDebouncedSearchValue()
  const { data } = useConversationsQuery({
    query: debouncedValue,
  })

  const expiringCount = data?.pages[data?.pages.length - 1].expiringCount || 0

  const { isOnboardingTooltipActive, onDismissOnboardingTooltip } = useOnboardingTooltip('expired_conversations')

  const showOnboardingTooltip = isOnboardingTooltipActive && expiringCount > 0

  if (!showOnboardingTooltip) return

  return (
    <div className="fixed bottom-2 left-[150px] z-50">
      <OnboardingTooltip
        content={
          (
            <p className="mb-5 text-base">{t('expired_conversations_onboarding')}</p>
          )
        }
        onCloseClick={onDismissOnboardingTooltip}
        open={showOnboardingTooltip}
        style={{ maxWidth: 310, zIndex: 50 }}
      >
        <span />
      </OnboardingTooltip>
    </div>
  )
}
